import {
  ITEM_OVERRIDE_FIELDS,
  type Item,
  type ItemOverrideField,
  type QuoteLineItemOverrides,
} from "@forgepoint/shared";

/**
 * Keeps the line overrides for fields the item leaves empty; null when none remain.
 * @param overrides - The line's current item overrides
 * @param item - The newly selected item, or undefined when there is none
 * @returns The overrides the item accepts, or null when none remain
 */
export function overridesAllowedForItem(
  overrides: QuoteLineItemOverrides | null | undefined,
  item: Pick<Item, ItemOverrideField> | undefined,
): QuoteLineItemOverrides | null {
  const kept = Object.fromEntries(
    ITEM_OVERRIDE_FIELDS.filter(
      (field) => overrides?.[field] && !item?.[field],
    ).map((field) => [field, overrides?.[field]]),
  );
  return Object.keys(kept).length > 0 ? kept : null;
}
